import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { MapPin, Phone, Mail, Instagram } from "lucide-react";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-[#2C2621] text-[#F3E6DA] mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-11 h-11 rounded-xl bg-[#8B5A3C] flex items-center justify-center text-white font-display text-lg font-semibold">
              LS
            </div>
            <div className="leading-tight">
              <div className="font-display text-xl font-semibold text-white">La Sala</div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-[#CBA37E]">Immobiliare</div>
            </div>
          </div>
          <p className="font-display italic text-2xl text-white/90 max-w-md leading-snug">
            {t.footer.tagline}
          </p>
          <div className="flex gap-3 mt-6">
            <a href="https://www.instagram.com/lasala_immobiliare_1/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#8B5A3C] hover:border-[#8B5A3C] transition-colors" aria-label="Instagram" data-testid="instagram-link">
              <Instagram size={16} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-[11px] uppercase tracking-[0.22em] text-[#CBA37E] mb-4 font-bold">{t.footer.quickLinks}</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-[#CBA37E] transition-colors">{t.nav.home}</Link></li>
            <li><Link to="/immobili" className="hover:text-[#CBA37E] transition-colors">{t.nav.properties}</Link></li>
            <li><Link to="/chi-siamo" className="hover:text-[#CBA37E] transition-colors">{t.nav.about}</Link></li>
            <li><Link to="/valutazione" className="hover:text-[#CBA37E] transition-colors">{t.nav.evaluation}</Link></li>
            <li><Link to="/contatti" className="hover:text-[#CBA37E] transition-colors">{t.nav.contact}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[11px] uppercase tracking-[0.22em] text-[#CBA37E] mb-4 font-bold">{t.footer.contactInfo}</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-2.5">
              <MapPin size={15} className="mt-0.5 text-[#CBA37E] shrink-0" />
              <span>Via Livia Gereschi 20<br/>56124 Pisa (PI)</span>
            </li>
            <li className="flex items-center gap-2.5">
              <Phone size={15} className="text-[#CBA37E] shrink-0" />
              <a href="tel:+393757380501" className="hover:text-[#CBA37E] transition-colors">375 738 0501</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Mail size={15} className="text-[#CBA37E] shrink-0" />
              <a href="mailto:segreteria@lasalaimmobiliare.it" className="hover:text-[#CBA37E] transition-colors break-all">segreteria@lasalaimmobiliare.it</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-white/60">
          <div>© {new Date().getFullYear()} La Sala Immobiliare. {t.footer.rights}</div>
          <div>{t.footer.legal}</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
